import { render } from "./ReferenceSubmission.vue?vue&type=template&id=2d62a090"
import script from "./ReferenceSubmission.vue?vue&type=script&lang=js"
export * from "./ReferenceSubmission.vue?vue&type=script&lang=js"

import "./ReferenceSubmission.vue?vue&type=style&index=0&id=2d62a090&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__